import { Card, Code, Group, Progress, Stack, Text } from '@mantine/core';
import HelpPopover from '../../HelpPopover/HelpPopover';
import { PanelCardTitle } from '../shared';
import { HELP } from './workspaceHelp';
import classes from './workspace.module.css';

// The profile's response-size ceiling for a store tool result.
export const AGENT_CHAR_LIMIT = 12000;

const pretty = (text) => {
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch {
    return text;
  }
};

// Exactly what the last Send hands the model (C7 agentText), its size and the fields left out.
const AgentView = ({ result }) => {
  const text = result.agentText ?? '';
  const chars = result.agentChars ?? text.length;
  const over = chars > AGENT_CHAR_LIMIT;
  const dropped = result.droppedFields || [];

  return (
    <Stack gap="xs">
      <Card withBorder padding="xs">
        <Group gap={4}>
          <PanelCardTitle>Sent to the agent</PanelCardTitle>
          <HelpPopover {...HELP.agentSees} />
        </Group>
        {text ? (
          <Code block style={{ maxHeight: 360, overflow: 'auto', fontSize: 11 }}>
            {pretty(text)}
          </Code>
        ) : (
          <Text size="xs" c="dimmed">
            Nothing.
          </Text>
        )}
        <Progress
          mt="xs"
          size="sm"
          color={over ? 'danger' : 'success'}
          value={Math.min(100, (chars / AGENT_CHAR_LIMIT) * 100)}
          aria-label="Size"
        />
        <Text size="xs" c={over ? 'red' : 'dimmed'} mt={4}>
          {chars.toLocaleString('en-US')} of {AGENT_CHAR_LIMIT.toLocaleString('en-US')} characters
          {result.mapped?.truncated && ' · rows were dropped from the end to fit'}
        </Text>
      </Card>
      {dropped.length > 0 && (
        <Card withBorder padding="xs">
          <PanelCardTitle>Not sent</PanelCardTitle>
          <Group gap={6}>
            {dropped.map((path) => (
              <Text key={path} size="xs" c="dimmed" className={classes.dropped}>
                {path}
              </Text>
            ))}
          </Group>
          <Text size="xs" c="dimmed" mt={4}>
            Add one as a field from the Response view if the agent needs it.
          </Text>
        </Card>
      )}
    </Stack>
  );
};

export default AgentView;
